import React, { useState, useRef, useEffect } from 'react';
import Menu from '../../../../../ui/components/Menu/Menu';
import MenuItem from '../../../../../ui/components/Menu/MenuItem';
import { PRIORITIZE_SECTIONS } from '../../../../../features/filters/constants/prioritizeSections';
import './PrioritizeToolbar.css';

export default function PrioritizeToolbar({
  visiblePrioritizeSections,
  onTogglePrioritizeSectionVisibility
}) {
  const [sectionsMenuOpen, setSectionsMenuOpen] = useState(false);
  const sectionsButtonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (sectionsButtonRef.current && !sectionsButtonRef.current.contains(e.target)) {
        setSectionsMenuOpen(false);
      }
    };
    if (sectionsMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [sectionsMenuOpen]);

  return (
    <div className="prioritize-toolbar">
      <div className="prioritize-toolbar-buttons">
        <div className="prioritize-toolbar-dropdown-wrap" ref={sectionsButtonRef}>
          <button
            type="button"
            className="prioritize-toolbar-btn prioritize-toolbar-btn-sections"
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => {
              setSectionsMenuOpen((prev) => !prev);
            }}
            aria-haspopup="true"
            aria-expanded={sectionsMenuOpen}
            aria-label="Sections visibility"
          >
            <svg width="12" height="12" viewBox="0 0 256 256" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden>
              <path fill="currentColor" d="M216 48H40a8 8 0 0 0-8 8v152a16 16 0 0 0 16 16h40a16 16 0 0 0 16-16v-48h48v16a16 16 0 0 0 16 16h40a16 16 0 0 0 16-16V56a8 8 0 0 0-8-8M88 208H48v-80h40Zm0-96H48V64h40Zm64 32h-48V64h48Zm56 32h-40v-48h40Zm0-64h-40V64h40Z"/>
            </svg>
            <span className="prioritize-toolbar-btn-label">Sections</span>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
              <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <Menu isOpen={sectionsMenuOpen} onClose={() => setSectionsMenuOpen(false)} align="left">
            {PRIORITIZE_SECTIONS.map(({ key, label }) => (
              <MenuItem
                key={key}
                isActive={visiblePrioritizeSections.has(key)}
                onClick={() => {
                  onTogglePrioritizeSectionVisibility(key);
                  setSectionsMenuOpen(false);
                }}
              >
                {label}
              </MenuItem>
            ))}
          </Menu>
        </div>
      </div>
    </div>
  );
}
